import { format, formatDistanceToNow, isValid, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

// Hallazgo verificando FE-03 con datos reales: un vehículo sin posición
// (alta reciente por el panel de administración, sin GPS todavía) llega con
// `lastSeen: ''` — `date-fns` lanza `RangeError` ante una fecha inválida y
// tumbaba MonitoringPage/VehiclesPage enteras. Sin fecha real, no hay nada
// que formatear: se muestra un placeholder en vez de reventar la pantalla.
const NO_DATE = '—';

export const formatDate = (iso: string): string => {
  const date = parseISO(iso);
  return isValid(date) ? format(date, "dd MMM yyyy, HH:mm", { locale: es }) : NO_DATE;
};

export const formatDateShort = (iso: string): string => {
  const date = parseISO(iso);
  return isValid(date) ? format(date, "dd/MM/yy HH:mm", { locale: es }) : NO_DATE;
};

export const formatRelative = (iso: string): string => {
  const date = parseISO(iso);
  return isValid(date) ? formatDistanceToNow(date, { addSuffix: true, locale: es }) : NO_DATE;
};

export const formatScore = (score: number): string => `${Math.round(score)}`;

/**
 * Kilometraje con separador de miles y sin decimales.
 *
 * Arreglado en FE-19 antes de usarlo por primera vez (tenía 0 llamadores, así
 * que el bug no se notaba): el odómetro real llega con 15 cifras significativas
 * (`905.158401441772`) y la versión anterior lo imprimía ENTERO en pantalla.
 * Y su abreviatura `"1.3k km"` decía menos que `"1.303 km"` para un odómetro,
 * donde lo que importa es el número exacto, no el orden de magnitud.
 */
export const formatKm = (km: number): string =>
  `${Math.round(km).toLocaleString('es-CO')} km`;

export const formatSpeed = (kmh: number): string => `${Math.round(kmh)} km/h`;

export const formatDuration = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = Math.round(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
};

export const getScoreColor = (score: number): string => {
  if (score >= 75) return '#10B981';
  if (score >= 45) return '#F59E0B';
  return '#EF4444';
};
